import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { StringKeyDictionary } from "../commonInterfaces";
import { Entity } from "../core/components/commonApp";
import {
    EditableGrid,
    EditableGridProps,
    field,
    InGridActions,
    InGridButtonClickParams,
    InGridToolBarButton,
    Schema
} from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { Helper } from "../core/util/helper";
import { EntityServiceReport } from "./serviceReport";
import React from "react";

export class ServiceReportEmailsInGrid extends React.Component<ServiceReportEmailsGridProps, {
}>{
    translations: StringKeyDictionary<string> = null;
    editableGridRef: EditableGrid;

    constructor(props: any) {
        super(props);
        this.state = {
            Schema: null,
            Columns: null
        }
        this.translations = this.props.translations;
    }

    private flag: boolean = false;
    onGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            this.handleItemChanged(fieldName, dataItems);
            this.flag = false;
        }
        else if (action == "add") {
        }
        else if (action == "remove") {

        }
        this.props.onChange();
    }

    private async handleItemChanged(fieldName: string, dataItems) {
        let changedDataItem = dataItems[0];
        this.flag = true;
        changedDataItem.set("Changed", true);
    }

    createNewEntry = (): EntityServiceReportEMailRecipient => {
        let emailRecipientEntity: EntityServiceReportEMailRecipient = {
            IsNew: true,
            Isguid: kendo.guid(),
            RecordRight: { CanRead: this.props.entity.RecordRight.CanRead, CanWrite: this.props.entity.RecordRight.CanWrite },
            Changed: true,
            IsWatchable: false,
            IsWatched: false,
            IndividualFields: {},
            //Adrnr: this.props.entity.Adrnr
        };
        return emailRecipientEntity;
    }

    private calcNewValues(dataSource: kendo.data.DataSource, newEntry: EntityServiceReportEMailRecipient) {
        let entries = (dataSource.data() as any) as EntityServiceReportEMailRecipient[];
        let destroyedData = dataSource["destroyed"]();

        let newPos = 1;

        if (entries.length >= 1) {
            newPos = entries.filter(x => Helper.hasValue(x.Pos)).reduce((prev, current) => (prev.Pos > current.Pos) ? prev : current).Pos + 1;
        }
        if (destroyedData.length >= 1) {
            let destroyedMaxPos = destroyedData.filter(x => Helper.hasValue(x.Pos)).reduce((prev, current) => (prev.Pos > current.Pos) ? prev : current).Pos + 1;
            if (destroyedMaxPos > newPos)
                newPos = destroyedMaxPos;
        }

        newEntry.Pos = newPos;
    }

    addContactFromSearch = (actions: InGridActions) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/contact?adrnr=" + this.props.entity.Adrnr + "&fullObject=true", null, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, (data) => {
            var newMaterial: EntityServiceReportEMailRecipient = this.createNewEntry();
            newMaterial.Email = data.email1;
            newMaterial.Fullname = data.ansprechpartner;
            actions.add(newMaterial);
        });
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem = this.createNewEntry();
                this.calcNewValues(p.dataSource, newItem);
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
            case "selectContact":
                this.addContactFromSearch(p.actions);
                break;
        }
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "selectContact",
            iconClass: "fal fa-id-badge",
            caption: Helper.getTranslation("ServiceReport.SelectContact")
        })

        let schema = new Schema();
        schema.Id = "Pos";
        schema.fields["Pos"] = new field("number");
        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid 
                editable={editable}
                data={this.props.data}
                schema={schema}
                gridOptions={this.props.gridOptions}
                ref={(ref) => this.editableGridRef = ref}
                onDataChanged={this.onGridDataChanged}
                validatable={false}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                {...this.props}
                id="srEmails"
            />
        </div>
    }
}

export interface ServiceReportEmailsGridProps extends EditableGridProps {
    entity: EntityServiceReport;
    data: EntityServiceReportEMailRecipient[];
    gridOptions: any;
    dataSources: any;
    translations: StringKeyDictionary<string>;
    onChange?: () => void;
}

export interface EntityServiceReportEMailRecipient extends Entity {
    Pos?: number;
    Isguid?: string;
    ContactPersonIsGuid?: string;
    Fullname?: string;
    Email?: string;
    Changed?: boolean;
}